import SideBarOptions from "base/src/utils/SideBarOptions";

export const sideBarOptions: Array<SideBarOptions> = [
  {
    Title: 'Início',
    LinkTo: '/',
    Icon: 'ic:round-home',
    home: true

  },
  {
    Title: 'Extrato',
    LinkTo: '/extrato',
    Icon: 'ic:baseline-attach-money'
  },


  // {
  //   Title: 'Depositar',
  //   LinkTo: '/deposito',
  //   Icon: 'mingcute:pig-money-fill'
  // },
  // {
  //   Title: 'Aprovar Pedidos',
  //   LinkTo: '/resgate/historico',
  //   Icon: 'uil:check-circle',
  // },
  // {
  //   Title: 'Realizar Pagamento',
  //   LinkTo: '/resgate',
  //   Icon: 'uil:money-withdrawal'
  // },
  {
    Title: 'Histórico',
    LinkTo: '/pagamento/historico',
    Icon: 'material-symbols:history'
  },
  {
    Title: 'Boletos',
    LinkTo: '/boletos',
    Icon: 'material-symbols:history'
  },
  {
    Title: 'Adminstrativo',
    LinkTo: '/admin',
    Icon: 'material-symbols:admin-panel-settings'
  },

  // {
  //   Title: 'Configurações',
  //   LinkTo: '/configuracao',
  //   Icon: 'uil:money-withdrawal'
  // },
]